import { ProductImages } from './product.images';
import { COLOR_ATTRIBUTE, CAPACITY_ATTRIBUTE, TOP_FEATURES_ATTRIBUTE, TOP_SMARTPHONE_ATTRIBUTE, IMAGE_SHOWCASE_ATTRIBUTE, BUNDLE_ATTRIBUTE, COLOR_RGB_ATTRIBUTE } from './product.attribute';
import { leftPad } from '../../utils/left-pad';
var Product = /*@__PURE__*/ (function () {
    function Product(data) {
        this.type = 'hardwareMobile';
        this.topSmartphoneDealUsed = false;
        this.onChangeListeners = [];
        this.onChangeListenerTimeouts = {};
        this.shouldStopEventListeners = false;
        this.topSmartphoneDealDisabled = false;
        this.keyColor = 'color';
        this.keyCapacity = 'capacity';
        this.keyRGBValue = 'rgb-code';
        this.currentVersion = 0;
        if (data) {
            if (data.id) {
                this.id = parseInt(data.id, 10);
            }
            if (data.label) {
                this.label = data.label;
            }
            if (data.additional) {
                this.additional = data.additional;
            }
            if (data.currentVersion) {
                this.currentVersion = data.currentVersion;
            }
            this.products = [];
        }
    }
    Product.prototype.loadJSON = function (data) {
        if (data) {
            this.id = data.id;
            this.label = data.label;
            this.additional = data.additional;
            this.currentVersion = data.currentVersion;
            this.products = data.products;
        }
    };
    Product.prototype.toJSON = function () {
        return {
            id: this.id,
            label: this.label,
            additional: this.additional,
            currentVersion: this.currentVersion,
            products: this.products
        };
    };
    Product.prototype.stopEventListeners = function () {
        this.shouldStopEventListeners = true;
    };
    Product.prototype.resumeEventListeners = function () {
        this.shouldStopEventListeners = false;
    };
    Product.prototype.getImages = function () {
        var images = new ProductImages();
        var product = this.getCurrentVersion();
        if (product.additional) {
            if (product.additional.imageLarge) {
                images.large = product.additional.imageLarge;
            }
            if (product.additional.imageSmall) {
                images.small = product.additional.imageSmall;
            }
            if (product.additional.imageThumb) {
                images.thumb = product.additional.imageThumb;
            }
        }
        return images;
    };
    Product.prototype.getShowcaseImages = function () {
        var images = [];
        var version = this.getCurrentVersion();
        for (var _i = 0, _a = version.attributes; _i < _a.length; _i++) {
            var attribute = _a[_i];
            if (attribute.id === IMAGE_SHOWCASE_ATTRIBUTE) {
                images.push(attribute);
            }
        }
        images.sort(function (a, b) {
            if (a.sortOrder > b.sortOrder) {
                return -1;
            }
            if (a.sortOrder < b.sortOrder) {
                return 1;
            }
            return 0;
        });
        var result = [];
        for (var _b = 0, images_1 = images; _b < images_1.length; _b++) {
            var image = images_1[_b];
            result.push(image.value);
        }
        result.reverse();
        return result;
    };
    Product.prototype.getDeviceType = function () {
        var product = this.getCurrentVersion();
        return product.additional.deviceType;
    };
    Product.prototype.addVersion = function (version) {
        this.products.push(version);
    };
    Product.prototype.getCurrentVersion = function () {
        return this.products[this.currentVersion];
    };
    Product.prototype.getId = function () {
        var version = this.getCurrentVersion();
        return version.id;
    };
    Product.prototype.getLabel = function () {
        return this.label;
    };
    Product.prototype.getSpecificLabel = function () {
        var version = this.getCurrentVersion();
        return version.label;
    };
    Product.prototype.getManufacturer = function () {
        var version = this.getCurrentVersion();
        return version.additional.manufacturer;
    };
    Product.prototype.getSubsidizedWith = function () {
        var version = this.getCurrentVersion();
        return version.additional.subsidizedWith;
    };
    Product.prototype.getDeliveryTime = function () {
        var version = this.getCurrentVersion();
        return version.additional.deliveryTime;
    };
    Product.prototype.getSAPId = function () {
        var version = this.getCurrentVersion();
        return leftPad(version.additional.artnr, 8);
    };
    Product.prototype.getClassification = function () {
        var version = this.getCurrentVersion();
        return version.additional.classification;
    };
    Product.prototype.getVersions = function () {
        return this.products;
    };
    Product.prototype.selectVersion = function (version) {
        var match;
        for (var i in this.products) {
            if (this.products[i].id === version.id) {
                match = i;
                break;
            }
        }
        if (match > -1) {
            this.currentVersion = match;
            this.onChange();
        }
        else {
            throw new Error('Invalid product version provided.');
        }
    };
    Product.prototype.updateCurrentVersion = function () {
        var currentColor = this.getCurrentColor();
        var currentCapacity = this.getCurrentCapacity();
        for (var _i = 0, _a = this.products; _i < _a.length; _i++) {
            var version = _a[_i];
            var colorMatch = false;
            var capacityMatch = false;
            var topDealMatch = false;
            for (var _b = 0, _c = version.attributes; _b < _c.length; _b++) {
                var attribute = _c[_b];
                if (attribute.id === COLOR_ATTRIBUTE) {
                    if (attribute.value === currentColor) {
                        colorMatch = true;
                    }
                }
                if (attribute.id === CAPACITY_ATTRIBUTE) {
                    if (attribute.value === currentCapacity) {
                        capacityMatch = true;
                    }
                }
                if (attribute.id === TOP_SMARTPHONE_ATTRIBUTE) {
                    if (attribute.value === '1') {
                        topDealMatch = true;
                    }
                }
            }
            var firstMatch = colorMatch && capacityMatch;
            var finalMatch = firstMatch;
            if (this.hasTopSmartphoneDeal()) {
                if (this.usesTopSmartphoneDeal()) {
                    finalMatch = finalMatch && topDealMatch === true;
                }
                else {
                    finalMatch = finalMatch && topDealMatch === false;
                }
            }
            if (finalMatch) {
                this.selectVersion(version);
                return true;
            }
        }
        return false;
    };
    Product.prototype.getAllColors = function () {
        var colors = [];
        for (var _i = 0, _a = this.products; _i < _a.length; _i++) {
            var version = _a[_i];
            for (var _b = 0, _c = version.attributes; _b < _c.length; _b++) {
                var attribute = _c[_b];
                if (attribute.id === COLOR_ATTRIBUTE) {
                    if (colors.indexOf(attribute.value) < 0) {
                        colors.push(attribute.value);
                        break;
                    }
                }
            }
        }
        return colors;
    };
    Product.prototype.getAvailableCapacitiesForColors = function () {
        var _this = this;
        // [{'color': 'Schwarz', 'capacity': '64 GB'}, ...]
        var colorCapacityAttr = this.products.map(function (product) { return product.attributes; }).map(function (prodAttributes) {
            return prodAttributes.reduce(function (previousValue, currentValue) {
                previousValue[_this.keyColor] = currentValue.id == COLOR_ATTRIBUTE ?
                    currentValue.value : previousValue[_this.keyColor];
                previousValue[_this.keyCapacity] = currentValue.id == CAPACITY_ATTRIBUTE ?
                    currentValue.value : previousValue[_this.keyCapacity];
                previousValue[_this.keyRGBValue] = currentValue.id == COLOR_RGB_ATTRIBUTE ?
                    currentValue.value : previousValue[_this.keyRGBValue];
                return previousValue;
            }, {});
        });
        // {'Schwarz': [128,64,256], ...}
        var capacitiesForColors = colorCapacityAttr.reduce(function (previous, current) {
            if (!previous[current[_this.keyColor]]) {
                previous[current[_this.keyColor]] = [];
            }
            // "64 GB" => 64
            var capacity = +current[_this.keyCapacity].split(' ')[0];
            if (!previous[current[_this.keyColor]].includes(capacity)) {
                previous[current[_this.keyColor]].push(capacity);
            }
            return previous;
        }, {});
        var colorCodes = colorCapacityAttr.reduce(function (previous, current) {
            var colorCode = current[_this.keyRGBValue];
            if (!previous[current[_this.keyColor]] != colorCode) {
                previous[current[_this.keyColor]] = colorCode;
            }
            return previous;
        }, {});
        // {'Schwarz': [64,128,256], ...}
        Object.keys(capacitiesForColors).forEach(function (key) {
            capacitiesForColors[key].sort(function (a, b) { return a - b; });
        });
        return [capacitiesForColors, colorCodes];
    };
    Product.prototype.getColors = function () {
        var colors = [];
        for (var _i = 0, _a = this.products; _i < _a.length; _i++) {
            var version = _a[_i];
            var ignore = false;
            if (this.getCurrentCapacity()) {
                for (var _b = 0, _c = version.attributes; _b < _c.length; _b++) {
                    var attribute = _c[_b];
                    if (attribute.id === CAPACITY_ATTRIBUTE) {
                        if (attribute.value !== this.getCurrentCapacity()) {
                            ignore = true;
                        }
                    }
                }
            }
            if (ignore) {
                continue;
            }
            for (var _d = 0, _e = version.attributes; _d < _e.length; _d++) {
                var attribute = _e[_d];
                if (attribute.id === COLOR_ATTRIBUTE) {
                    if (colors.indexOf(attribute.value) < 0) {
                        colors.push(attribute.value);
                        break;
                    }
                }
            }
        }
        return colors;
    };
    Product.prototype.selectColor = function (color) {
        if (!color) {
            return this.getCurrentVersion();
        }
        this.currentColor = color;
        var match = this.updateCurrentVersion();
        return match;
    };
    Product.prototype.selectCapacity = function (capacity) {
        if (!capacity) {
            return this.getCurrentVersion();
        }
        this.currentCapacity = capacity;
        var match = this.updateCurrentVersion();
        return match;
    };
    Product.prototype.getAllCapacities = function () {
        var capacities = [];
        for (var _i = 0, _a = this.products; _i < _a.length; _i++) {
            var version = _a[_i];
            for (var _b = 0, _c = version.attributes; _b < _c.length; _b++) {
                var attribute = _c[_b];
                if (attribute.id === CAPACITY_ATTRIBUTE) {
                    if (capacities.indexOf(attribute.value) === -1) {
                        capacities.push(attribute.value);
                    }
                    break;
                }
            }
        }
        return capacities;
    };
    Product.prototype.getCapacities = function () {
        var capacities = [];
        for (var _i = 0, _a = this.products; _i < _a.length; _i++) {
            var version = _a[_i];
            var ignore = false;
            if (this.getCurrentColor()) {
                for (var _b = 0, _c = version.attributes; _b < _c.length; _b++) {
                    var attribute = _c[_b];
                    if (attribute.id === COLOR_ATTRIBUTE) {
                        if (attribute.value !== this.getCurrentColor()) {
                            ignore = true;
                        }
                    }
                }
            }
            if (ignore) {
                continue;
            }
            for (var _d = 0, _e = version.attributes; _d < _e.length; _d++) {
                var attribute = _e[_d];
                if (attribute.id === CAPACITY_ATTRIBUTE) {
                    if (capacities.indexOf(attribute.value) < 0) {
                        capacities.push(attribute.value);
                        break;
                    }
                }
            }
        }
        return capacities;
    };
    Product.prototype.getCurrentColor = function () {
        var version = this.getCurrentVersion();
        if (this.currentColor) {
            return this.currentColor;
        }
        for (var _i = 0, _a = version.attributes; _i < _a.length; _i++) {
            var attribute = _a[_i];
            if (attribute.id === COLOR_ATTRIBUTE) {
                this.currentColor = attribute.value;
                return attribute.value;
            }
        }
        return false;
    };
    Product.prototype.getCurrentCapacity = function () {
        var version = this.getCurrentVersion();
        if (this.currentCapacity) {
            return this.currentCapacity;
        }
        for (var _i = 0, _a = version.attributes; _i < _a.length; _i++) {
            var attribute = _a[_i];
            if (attribute.id === CAPACITY_ATTRIBUTE) {
                this.currentCapacity = attribute.value;
                return attribute.value;
            }
        }
        return false;
    };
    Product.prototype.hasTopSmartphoneDeal = function () {
        var version = this.getCurrentVersion();
        var currentColor = this.getCurrentColor();
        var currentCapacity = this.getCurrentCapacity();
        for (var _i = 0, _a = this.products; _i < _a.length; _i++) {
            var product = _a[_i];
            var colorMatch = false;
            var capacityMatch = false;
            var topDealMatch = false;
            for (var _b = 0, _c = product.attributes; _b < _c.length; _b++) {
                var attribute = _c[_b];
                if (attribute.id === COLOR_ATTRIBUTE) {
                    if (attribute.value === currentColor) {
                        colorMatch = true;
                    }
                }
                if (attribute.id === CAPACITY_ATTRIBUTE) {
                    if (attribute.value === currentCapacity) {
                        capacityMatch = true;
                    }
                }
                if (attribute.id === TOP_SMARTPHONE_ATTRIBUTE) {
                    if (attribute.value === '1') {
                        topDealMatch = true;
                    }
                }
            }
            if (colorMatch && capacityMatch && topDealMatch) {
                return true;
            }
        }
        return false;
    };
    Product.prototype.useTopSmartphoneDeal = function () {
        var currentColor = this.getCurrentColor();
        var currentCapacity = this.getCurrentCapacity();
        for (var _i = 0, _a = this.products; _i < _a.length; _i++) {
            var product = _a[_i];
            var colorMatch = false;
            var capacityMatch = false;
            var topDealMatch = false;
            for (var _b = 0, _c = product.attributes; _b < _c.length; _b++) {
                var attribute = _c[_b];
                if (attribute.id === COLOR_ATTRIBUTE) {
                    if (attribute.value === currentColor) {
                        colorMatch = true;
                    }
                }
                if (attribute.id === CAPACITY_ATTRIBUTE) {
                    if (attribute.value === currentCapacity) {
                        capacityMatch = true;
                    }
                }
                if (attribute.id === TOP_SMARTPHONE_ATTRIBUTE) {
                    if (attribute.value === '1') {
                        topDealMatch = true;
                    }
                }
            }
            if (colorMatch && capacityMatch && topDealMatch) {
                this.topSmartphoneDealUsed = true;
                this.selectVersion(product);
                return;
            }
        }
        throw new Error('This product doesnt include top smartphone deals. To check if it products are supporting top smartphone deals, use the integrated method hasTopSmartphoneDeal()');
    };
    Product.prototype.unuseTopSmartphoneDeal = function () {
        if (!this.hasTopSmartphoneDeal()) {
            throw new Error('This product doesnt include top smartphone deals. To check if it products are supporting top smartphone deals, use the integrated method hasTopSmartphoneDeal()');
        }
        this.topSmartphoneDealUsed = false;
        var currentColor = this.getCurrentColor();
        var currentCapacity = this.getCurrentCapacity();
        this.selectColor(currentColor);
        this.selectCapacity(currentCapacity);
    };
    Product.prototype.disableTopSmartphoneDeal = function () {
        if (!this.hasTopSmartphoneDeal()) {
            throw new Error('This product doesnt include top smartphone deals. To check if it products are supporting top smartphone deals, use the integrated method hasTopSmartphoneDeal()');
        }
        this.topSmartphoneDealUsed = false;
        this.topSmartphoneDealDisabled = true;
        var currentColor = this.getCurrentColor();
        var currentCapacity = this.getCurrentCapacity();
        this.selectColor(currentColor);
        this.selectCapacity(currentCapacity);
    };
    Product.prototype.enableTopSmartphoneDeal = function () {
        if (!this.hasTopSmartphoneDeal()) {
            throw new Error('This product doesnt include top smartphone deals. To check if it products are supporting top smartphone deals, use the integrated method hasTopSmartphoneDeal()');
        }
        this.topSmartphoneDealUsed = true;
        this.topSmartphoneDealDisabled = false;
        var currentColor = this.getCurrentColor();
        var currentCapacity = this.getCurrentCapacity();
        this.selectColor(currentColor);
        this.selectCapacity(currentCapacity);
    };
    Product.prototype.usesTopSmartphoneDeal = function () {
        return this.topSmartphoneDealUsed;
    };
    Product.prototype.hasEquivalentBundle = function () {
        var currentColor = this.getCurrentColor();
        var currentCapacity = this.getCurrentCapacity();
        for (var _i = 0, _a = this.products; _i < _a.length; _i++) {
            var version = _a[_i];
            var colorMatch = false;
            var capacityMatch = false;
            var bundleMatch = false;
            for (var _b = 0, _c = version.attributes; _b < _c.length; _b++) {
                var attribute = _c[_b];
                if (attribute.id === COLOR_ATTRIBUTE) {
                    if (attribute.value === currentColor) {
                        colorMatch = true;
                    }
                }
                if (attribute.id === CAPACITY_ATTRIBUTE) {
                    if (attribute.value === currentCapacity) {
                        capacityMatch = true;
                    }
                }
                if (attribute.id === BUNDLE_ATTRIBUTE) {
                    if (attribute.value) {
                        bundleMatch = attribute.value === '1';
                    }
                }
            }
            var finalMatch = colorMatch && capacityMatch && bundleMatch;
            if (finalMatch) {
                return true;
            }
        }
        return false;
    };
    Product.prototype.switchToEquivalentBundle = function () {
        var currentColor = this.getCurrentColor();
        var currentCapacity = this.getCurrentCapacity();
        for (var _i = 0, _a = this.products; _i < _a.length; _i++) {
            var version = _a[_i];
            var colorMatch = false;
            var capacityMatch = false;
            var bundleMatch = false;
            for (var _b = 0, _c = version.attributes; _b < _c.length; _b++) {
                var attribute = _c[_b];
                if (attribute.id === COLOR_ATTRIBUTE) {
                    if (attribute.value === currentColor) {
                        colorMatch = true;
                    }
                }
                if (attribute.id === CAPACITY_ATTRIBUTE) {
                    if (attribute.value === currentCapacity) {
                        capacityMatch = true;
                    }
                }
                if (attribute.id === BUNDLE_ATTRIBUTE) {
                    if (attribute.value) {
                        bundleMatch = attribute.value === '1';
                    }
                }
            }
            var finalMatch = colorMatch && capacityMatch && bundleMatch;
            if (finalMatch) {
                this.selectVersion(version);
                return;
            }
        }
    };
    Product.prototype.switchToEquivalentWithoutBundle = function () {
        var currentColor = this.getCurrentColor();
        var currentCapacity = this.getCurrentCapacity();
        for (var _i = 0, _a = this.products; _i < _a.length; _i++) {
            var version = _a[_i];
            var colorMatch = false;
            var capacityMatch = false;
            var bundleMatch = false;
            for (var _b = 0, _c = version.attributes; _b < _c.length; _b++) {
                var attribute = _c[_b];
                if (attribute.id === COLOR_ATTRIBUTE) {
                    if (attribute.value === currentColor) {
                        colorMatch = true;
                    }
                }
                if (attribute.id === CAPACITY_ATTRIBUTE) {
                    if (attribute.value === currentCapacity) {
                        capacityMatch = true;
                    }
                }
                if (attribute.id === BUNDLE_ATTRIBUTE) {
                    if (attribute.value) {
                        bundleMatch = attribute.value === '1';
                    }
                }
            }
            var finalMatch = colorMatch && capacityMatch && !bundleMatch;
            if (finalMatch) {
                this.selectVersion(version);
                return;
            }
        }
    };
    Product.prototype.currentVersionContainsBundle = function (product) {
        if (!product) {
            product = this.getCurrentVersion();
        }
        for (var _i = 0, _a = product.attributes; _i < _a.length; _i++) {
            var attribute = _a[_i];
            if (attribute.id === BUNDLE_ATTRIBUTE) {
                if (attribute.value) {
                    return attribute.value === '1';
                }
            }
        }
        return false;
    };
    Product.prototype.currentVersionHasTopSmartphoneDeal = function () {
        var product = this.getCurrentVersion();
        for (var _i = 0, _a = product.attributes; _i < _a.length; _i++) {
            var attribute = _a[_i];
            if (attribute.id === TOP_SMARTPHONE_ATTRIBUTE) {
                if (attribute.value === '1') {
                    return true;
                }
            }
        }
        return false;
    };
    Product.prototype.getTopFeatures = function () {
        var version = this.getCurrentVersion();
        var topFeatures = [];
        for (var _i = 0, _a = version.attributes; _i < _a.length; _i++) {
            var attribute = _a[_i];
            if (attribute.id === TOP_FEATURES_ATTRIBUTE) {
                topFeatures.push(attribute.value);
            }
        }
        return topFeatures;
    };
    Product.prototype.getAttributeById = function (id) {
        var version = this.getCurrentVersion();
        for (var _i = 0, _a = version.attributes; _i < _a.length; _i++) {
            var attribute = _a[_i];
            if (attribute.id === id) {
                return attribute;
            }
        }
        return false;
    };
    Product.prototype.subscribe = function (event, callback) {
        if (event === 'change') {
            this.onChangeListeners.push(callback);
        }
    };
    Product.prototype.onChange = function () {
        var _this = this;
        if (this.shouldStopEventListeners) {
            return;
        }
        for (var listener in this.onChangeListeners) {
            if (this.onChangeListenerTimeouts[listener]) {
                clearTimeout(this.onChangeListenerTimeouts[listener]);
            }
            this.onChangeListenerTimeouts[listener] = setTimeout(function () {
                _this.onChangeListeners[listener]();
            }, 1);
        }
    };
    return Product;
}());
export { Product };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/schema/product/product.ts
// module id = null
// module chunks = 